module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-lgrey",
    attrs: {
      "id": "objects"
    }
  }, [_c('tooltips', {
    attrs: {
      "tippy": _vm.tooltipsData,
      "transparent": true
    }
  }), _vm._v(" "), _c('button', {
    ref: "add_box_btn",
    staticClass: "add_box_btn",
    on: {
      "click": _vm.highlightRowForBoxes
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/box.svg"
    }
  })]), _vm._v(" "), _c('room', {
    attrs: {
      "endline": "false",
      "display": "block"
    }
  }, _vm._l((_vm.rows), function(row, row_index) {
    return _c('krossingrow', {
      key: 'up' + row_index,
      style: (row.style),
      attrs: {
        "height": _vm.heights[row.height],
        "disable-hover": true,
        "enabled": _vm.showRowsForBoxes && row.height == 'm'
      }
    }, _vm._l((_vm.objects()[row_index]), function(object, obj_index) {
      return _c('krossingobject', {
        key: row_index * obj_index,
        attrs: {
          "enable-hover": _vm.currentBoxIndex === null,
          "imagepath": ("/images/krossing/" + (row.height) + "/"),
          "image": [ '01.svg', '02.svg'],
          "active": object.active,
          "disabled": object.disabled,
          "isbox": object.is_box,
          "wood": object.wood,
          "frontal": object.frontal_props,
          "material": object.material_props,
          "width": row.object_width
        },
        on: {
          "click": function($event) {
            _vm.addObject(row_index, obj_index)
          }
        }
      })
    }))
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.currentBoxIndex !== null) ? _c('div', {
    staticClass: "boxes_menu"
  }, [_c('div', {
    staticClass: "boxes_menu_head"
  }, [_c('h6', {
    staticClass: "h6"
  }, [_vm._v(_vm._s(_vm.$t("kr_insert")))]), _vm._v(" "), _c('span', {
    staticClass: "h7"
  }, [_vm._v(_vm._s(_vm.$t("kr_insert_body")))]), _vm._v(" "), _c('img', {
    staticClass: "box_menu_image",
    attrs: {
      "src": "/images/box_element.svg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxes_menu_colors"
  }, _vm._l((_vm.materials), function(material) {
    return _c('button', {
      staticClass: "boxes_menu_color",
      on: {
        "click": function($event) {
          _vm.editBox(material)
        }
      }
    }, [_c('div', {
      staticClass: "boxes_menu_circle",
      style: (!material.img ? {
        backgroundColor: material.css_color,
        color: material.txt_color
      } : {
        backgroundImage: 'url(' + material.img + ')',
        color: material.txt_color
      })
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t(material.key)[0]) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('span', {
      staticClass: "h7 regular c-dark"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t(material.key)) + "\n\t\t\t\t\t")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "boxes_menu_buttons"
  }, [_c('button', {
    staticClass: "bg-lgrey c-dark h7",
    on: {
      "click": _vm.deleteCurrentBox
    }
  }, [_vm._v("ELIMINA")]), _vm._v(" "), _c('button', {
    staticClass: "bg-accent c-light h7",
    on: {
      "click": _vm.confirmCurrentBox
    }
  }, [_vm._v("CONFERMA")])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7792691d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/objects/Krossing.vue
// module id = 646
// module chunks = 0